import { Component, OnInit, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ActionSheetController, PopoverController } from 'ionic-angular';

import { SevaData } from '../../models/SevaData';
import { Gotra } from '../../models/Gotra';
import { Nakshatra } from '../../models/Nakshatra';
import { Seva, Tithi, Paksha, Maasa } from '../../models/Seva';
import { SevalistforBooking } from '../../models/SevalistforBooking';
import { PostSevaBooking } from '../../models/PostSevaBooking';
//import { PdfPage } from '../pdf/pdf';
import { DatePipe } from '@angular/common';
//import { saveAs } from 'file-saver';
import { SevaBookingResponse } from '../../models/SevaBookingResponse';

import { App } from 'ionic-angular';
import { User, Categories } from '../../models/User';
import { RestProvider } from '../../providers/rest/rest';
import { CalanderPage } from '../calander/calander';
import { Calender } from '../../models/Calander';
import { Locals } from '../../models/localmodel';
import { Sevacategorty } from '../../models/PostLogin';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import { ShashwathaSeva } from '../../models/shashwathaSeva';
import { PopoverPage } from '../popover/popover';
import { NON_TEXT_INPUT_REGEX } from 'ionic-angular/umd/util/dom';
// import { lifecycle } from '@angular/core/src/render3';


@Component({
  selector: 'page-home',
  templateUrl: 'home.html',

})
export class HomePage implements OnInit {
  @ViewChild('check') check;
  stype: string = "regular";
  ctype: string = "cash";
  mobile_number: any;
  name: string = "";
  gotra: string = "";
  seva_date: any;
  token_numbers: any;
  token_numbersfrom: number;
  token_numbersto: number;
  sp_request: string;
  veda: string;
  nakshatra: any;
  seva_time: any;
  addl_people: number = 1;
  cashmode: boolean = true;
  phone_array: any;
  gotra_array: Gotra[];
  nakshatra_array: Nakshatra[];
  seva_array: Seva[];
  show_gotra_array: boolean = false;
  show_nakshatra_array: boolean = false;

  //Sub arrays
  Regular_seva_array: Seva[] = [];
  Special_seva_array: Seva[] = [];
  Aradhane_seva_array: Seva[] = [];
  Building_seva_array: Seva[] = [];
  selected_seva_array: Seva[] = [];
  seva_seleced_list: SevalistforBooking[] = [];
  is_seva_checked: boolean = false;
  seva_amount_edited: number = 0;
  seva_persons_edited: number = 0;
  seva_amount_total: number = 0;
  today: any;
  Account_detail: any;
  token_color: string = 'CE0000';
  temp: any;
  seva_list_amount: number;
  deselected_seva_amount: number = 0;
  public postseva = new PostSevaBooking();
  payment_type: number; //Default to cash.
  show_user_list: boolean = false;
  user_array: User[] = [];
  user: User;
  calander_details: Calender;
  sava_date: Date;
  seva_month: any;
  seva_year: any;
  seva_masa: any;
  seva_paksha: any;
  seva_thithi: any;
  seva_shradda_thithi: any;
  seva_samvatsara: any;
  seva_day: any;
  sevapassed: boolean = false;
  temp_date: any;
  tokensum: number = 0;
  selected_sevas_repopulated: any;
  index: any;
  disableregular: boolean = true;
  disablespecial: boolean = true;
  disablearadhane: boolean = true;
  disablebuilding: boolean = true;
  disableshashwathaseva: boolean = true;
  disablepratishtapanaseva: boolean = true;
  user_categories: Sevacategorty[] = [];
  userrole: User;
  shashwatha_seva_array: Seva[] = [];
  shashwatha_seva: string;
  showshashwathasevas: boolean = false;
  fromdate: any;
  todate: any;
  week_array: any;
  thithi_array: Tithi[] = [];
  showthithis: boolean = false;
  paksha_array: Paksha[] = [];
  showpaksha: boolean = false;
  maasa_array: Maasa[] = [];
  showmaasa: boolean = false;
  shashwatha_nakshatra_array: Nakshatra[] = [];
  shownakshatra: boolean = false;
  showweekdays: boolean = false;
  week_day: any;
  thithi_for_shashwathaseva: any;
  paksha_for_shashwathaseva: any;
  maasa_for_shashwathaseva: any;
  nakshatra_for_shashwathaseva: any;
  shashwathasevadate: any;
  repeat_type: string = 'daily';
  disabletithi: boolean = false;
  disablenakshatra: boolean = false;
  emailid: string = null;
  Pratishtapana_seva_array: Seva[] = [];
  SilverJubilee_seva_array: Seva[] = [];
  zeroamountadded:boolean = false;
  constructor(public navCtrl: NavController, public navParams: NavParams, private alertController: AlertController, private restProvider: RestProvider, private datePipe: DatePipe, public appCtrl: App, public actionSheetCtrl: ActionSheetController, public popoverCtrl: PopoverController) {
    console.log(this.check);
  }
  ngOnInit() {

    this.gotra_array = [];
    this.nakshatra_array = [];
    this.seva_array = [];
    this.Regular_seva_array = [];
    this.Special_seva_array = [];
    this.Aradhane_seva_array = [];
    this.selected_seva_array = [];
    this.Pratishtapana_seva_array = [];
    this.SilverJubilee_seva_array = [];
    this.fromdate = new Date().toISOString();
    this.fromdate = this.datePipe.transform(this.fromdate, "yyyy-MM-dd");
    this.todate = new Date().toISOString();
    this.todate = this.datePipe.transform(this.todate, "yyyy-MM-dd");
    this.week_array = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    this.week_day = this.week_array[0];
    this.user = this.navParams.get('user');
    this.calander_details = this.navParams.get('calander');
    // console.log("cal details in home.ts",this.calander_details);
    console.log("user details in home.ts", this.user);
    let t: Locals = this.navParams.get('local');

    console.log("t", t);
    this.user_categories = JSON.parse(localStorage.getItem("seva_categories"))
    this.userrole = JSON.parse(localStorage.getItem("srm_user"))
    let default_tab: number;
    // if(this.user_categories)
    // {
    //   default_tab = this.user_categories[0].id;
    //   if(default_tab == 1)
    //   {
    //     this. stype = "regular";
    //   }
    //   else if(default_tab == 2)
    //   {
    //     this.stype = "special";
    //   }
    //   else if(default_tab == 3)
    //   {
    //     this.stype = "aradhane";
    //   }
    //   else if(default_tab == 4)
    //   {
    //     this.stype == "building";
    //   }
    // }

    if (!t) {
      if (localStorage.getItem("seva_categories")) {
        console.log("got user_categories in home.ts")

        if (localStorage.getItem("srm_user")) {
          this.userrole = JSON.parse(localStorage.getItem("srm_user"))
        }

        // if(user_categories.length == 1 && user_categories[0].id == 3)
        // {
        //   this.stype = 'aradhane';
        // }
        // else{
        //   this.stype = 'regular';
        // }



      }
      else {
        //this.stype = 'regular';
      }

      this.token_numbersfrom = 0;
      this.token_numbersto = 0;
      this.tokensum = 0;
    }
    else {
      // let user_categories:Sevacategorty[] = [];
      // let user:User;
      // if(localStorage.getItem("seva_categories"))
      // {
      //   console.log("got user_categories in home.ts")
      //   user_categories = JSON.parse(localStorage.getItem("seva_categories"));
      // }
      // if(localStorage.getItem("srm_user"))
      // {
      //  this.userrole = JSON.parse(localStorage.getItem("srm_user"));
      // }

      this.stype = t.stype;
      if (this.userrole) {
        this.disablesegments();
      }

      this.payment_type = t.ptype;
      this.Account_detail = t.accdetail;
      this.token_numbersfrom = t.tokenfrom;
      this.token_numbersto = t.tokento;
      this.token_numbers = t.tokens;
      this.sp_request = t.sprequest
      this.addl_people = t.addlppl;
    }



    // this.today = new Date().toISOString();
    // console.log(this.today);
    //  this.seva_date = new Date('2018-11-28').toISOString();//this.today;
    this.seva_time = "10:00";
    this.show_gotra_array = false;
    this.show_nakshatra_array = false;
    this.show_user_list = false;
    console.log("seva date details passed from calendar screen:", this.calander_details)
    this.GetSevadata(1);
    this.GetSevadata(2);
    this.GetSevadata(3);
    this.GetSevadata(4);
    this.GetSevadata(5);
    this.GetSevadata(6);
    this.GetSevadata(7);
    this.getshashwathasevastandingData();



    if (this.user) {
      this.name = this.user.name;
      this.mobile_number = this.user.phone;
      this.gotra = this.user.gotra;
      this.emailid = this.user.emailid;
      this.nakshatra = this.user.nakshatra;
      this.veda = this.user.veda;
    }

    if (this.calander_details) {
      if (this.calander_details.date != null) {
        this.sevapassed = true;
      }

      this.seva_masa = this.calander_details.maasa;
      this.seva_thithi = this.calander_details.tithi;
      this.seva_shradda_thithi = this.calander_details.shraddatithi;
      this.seva_samvatsara = this.calander_details.samvatsara;
      this.seva_paksha = this.calander_details.paksha;
      this.seva_date = this.calander_details.date;
      //console.log("init date",this.seva_date)
      this.temp_date = new Date(this.calander_details.date).getDate();
      //console.log(this.temp_date)
      this.seva_year = this.calander_details.year;
      this.seva_month = this.calander_details.month;
      this.seva_day = this.calander_details.week_day;
    }

    //this.selectedRegular();

    this.selected_sevas_repopulated = this.navParams.get('sevas');
    console.log(this.selected_sevas_repopulated)


    if (this.selected_sevas_repopulated) {
      this.selected_seva_array = this.selected_sevas_repopulated
      //this.GetSevadata();
      //console.log("result populated")
    }


  }
  ionViewWillEnter() {
    console.log("inside viewdidenter")
    this.disablesegments();
  }
  disablesegments() {
    if (localStorage.getItem("seva_categories")) {
      console.log("got user_categories in disablesegments method")
      this.user_categories = JSON.parse(localStorage.getItem("seva_categories"));
    }
    if (localStorage.getItem("srm_user")) {
      this.userrole = JSON.parse(localStorage.getItem("srm_user"));
    }
    if (this.userrole) {
      console.log("userrole", this.userrole.user_role)
      if (this.userrole.user_role < 3) {

        for (let i = 0; i < this.user_categories.length; i++) {
          // switch (this.user_categories[i].id)
          // {
          //  case 1 :
          //  this.disableregular = false;
          //           // this.disablespecial = true;
          //           // this.disablearadhane = true;
          //           // this.disablebuilding = true;

          //           break;
          //  case 2 :
          //            this.disablespecial = false;
          //            //this.disableregular = true;
          //             //this.disablearadhane = true;
          //              //this.disablebuilding = true;
          //           break;
          //   case 3 :
          //            this.disablearadhane = false;
          //         //  this.disableregular = true;
          //         //    this.disablespecial = true;

          //           //this.disablebuilding = true;
          //           break;
          //           case 4 :
          //           this.disablebuilding = false;
          //           // this.disableregular = true;
          //           //    this.disablespecial = true;
          //           //    this.disablearadhane = true;

          //           break;
          //   default:this.disableregular = false;
          //           this.disablespecial = false;
          //           this.disablearadhane = false;
          //           this.disablebuilding = false;
          // }

          if (this.user_categories[i].id == 1) {
            console.log("inside user cat id 1")
            this.disableregular = false;
          }
          if (this.user_categories[i].id == 2) {
            console.log("inside user cat id 2")
            this.disablespecial = false;
          }
          if (this.user_categories[i].id == 3) {
            console.log("inside user cat id 3")
            this.disablearadhane = false;
          }
          if (this.user_categories[i].id == 4) {
            console.log("inside user cat id 4")
            this.disablebuilding = false;
          }
          if(this.user_categories[i].id == 5)
        {
          console.log("inside user cat id 5")
          this.disableshashwathaseva = false;
        }
        if(this.user_categories[i].id == 6)
        {
          console.log("inside user cat id 5")
          this.disablepratishtapanaseva = false;
        }
        } // end of for
        console.log("disableregular", this.disableregular);
        console.log("disablespecial", this.disablespecial);
        console.log("disablearadhane", this.disablearadhane);
        console.log("disablebuilding", this.disablebuilding);
        console.log("disablebuilding", this.disablepratishtapanaseva);
      }
      else {

        this.disableregular = false;
        this.disablespecial = false;
        this.disablearadhane = false;
        this.disablebuilding = false;
        this.disablepratishtapanaseva = false;
      }
    }
    let t: Locals = this.navParams.get('local');

    console.log("t", t);
    if (this.user_categories.length > 0) {
      if (t) {
        this.stype = t.stype;
      }
      else {
        let default_tab: number;
        default_tab = this.user_categories[0].id;
        if (default_tab == 1) {
          this.stype = "regular";
        }
        else if (default_tab == 2) {
          this.stype = "special";
        }
        else if (default_tab == 3) {
          this.stype = "aradhane";
        }
        else if (default_tab == 4) {
          this.stype == "building";
        }
        else if(default_tab == 5)
        {
          this.stype == "shashwathaseva";
        }
        else if(default_tab == 6)
        {
          this.stype == "pratishtapana";
        }else if(default_tab == 6)
        {
          this.stype == "pratishtapana";
        }
      }
    }
  }

  //Function for getting sevadata
  GetSevadata(id: number) {
    console.log("id before paasing",id);
    //Calling seva details from the server (seva,gotra,nakshatra)
    this.restProvider.getSevacategory().subscribe(
      (result) => {
        console.log(result);
      },
      error => {
        console.log(error);

      }
    )


    this.restProvider.getSevas(id)
      .subscribe(
        (result: any) => {
          console.log("sevas result for the seva id", result);

          if (result) {
            if (id == 1) {
              this.Regular_seva_array = result.data;
            }
            if (id == 2) {
              this.Special_seva_array = result.data;
            }
            if (id == 3) {
              this.Aradhane_seva_array = result.data;
            }
            if (id == 4) {
              this.Building_seva_array = result.data;
            }
            if (id == 5) {
              this.shashwatha_seva_array = result.data;
            if(this.shashwatha_seva_array.length> 0){
              this.shashwatha_seva = this.shashwatha_seva_array[0].sevaname;
  }
              this.getshashwathasevastandingData();
            }
            if (id == 6) {
              this.Pratishtapana_seva_array = result.data;
            }
            if (id == 7) {
              this.SilverJubilee_seva_array = result.data;
            }

            //console.log("sevas with regular category",this.Regular_seva_array);
            // console.log("sevas with special category",this.Special_seva_array);
            // console.log("sevas with aradhane category", this.Aradhane_seva_array);
            if (this.selected_seva_array.length > 0) {
              this.seva_amount_total = 0;
              for (let i = 0; i < this.selected_seva_array.length; i++) {
                let x = this.selected_seva_array[i].sevacategory;
                let row = this.selected_seva_array[i]
                //console.log("sevacategory ",x)
                if (x == "REGULAR") {
                  console.log("row", row)
                  let t = this.Regular_seva_array.find((item) => item.sevaname == row.sevaname);
                  console.log("t", t)
                  if (t) {
                    t.checked = true;
                  }

                }
                if (x == "SPECIAL") {
                  //console.log("row",row)
                  let t = this.Special_seva_array.find((item) => item.sevaname == row.sevaname);
                  //console.log("t",t)
                  if (t) {
                    t.checked = true;
                  }

                }
                if (x == "ARADHANA") {
                  //console.log("row",row)
                  let t = this.Aradhane_seva_array.find((item) => item.sevaname == row.sevaname);
                  console.log("t", t)
                  if (t) {
                    t.checked = true;
                  }

                }
                if (x == "BUILDING FUND") {
                  //console.log("row",row)
                  let t = this.Building_seva_array.find((item) => item.sevaname == row.sevaname);
                  //console.log("t",t)
                  if (t) {
                    t.checked = true;
                  }


                }
                if (x == "PRATISHTAPANA") {
                  //console.log("row",row)
                  let t = this.Pratishtapana_seva_array.find((item) => item.sevaname == row.sevaname);
                  //console.log("t",t)
                  if (t) {
                    t.checked = true;
                  }


                }
                if (x == "SILVER JUBILEE") {
                  //console.log("row",row)
                  let t = this.SilverJubilee_seva_array.find((item) => item.sevaname == row.sevaname);
                  //console.log("t",t)
                  if (t) {
                    t.checked = true;
                  }


                }

                this.seva_amount_total = +(this.seva_amount_total) + +(this.selected_seva_array[i].sevaamount);


              }

            }


          }
        },
        error => {
          console.log(error);
        }
      )
  }

  //Function for Regular Segment button click
  selectedRegular() {
    this.disablesegments();
    this.restProvider.getSevas(1).subscribe(
      (result: any) => {
        //console.log("selectedRegular",result);
        if (result) {
          this.Regular_seva_array = result.data;

        }

        //console.log("selectedRegular 2",this.Regular_seva_array);
      },
      error => {
        console.log(error);
      }
    )
    this.token_numbersfrom = 1;
    for (let i = 0; i < this.selected_seva_array.length; i++) {
      this.selected_seva_array[i].checked = false;
      console.log(this.selected_seva_array[i].checked)
    }
    // this.selected_seva_array = [];
    // this.selected_seva_array.length = 0;

    this.seva_amount_total = 0;
    //this.token_color = '#ce0000';

    for (let i = 0; i < this.Regular_seva_array.length; i++) {
      //this.Regular_seva_array[i].checked = false;

    }




    this.ClearAllFields();

  }

  //Function for Special Segment button click
  selectedSpecial() {
    this.disablesegments();
    this.GetSevadata(2);

    for (let i = 0; i < this.selected_seva_array.length; i++) {
      this.selected_seva_array[i].checked = false;
      console.log(this.selected_seva_array[i].checked)
    }
    // this.selected_seva_array.splice(0);
    // this.selected_seva_array = [];
    // this.selected_seva_array.length = 0;
    this.seva_amount_total = 0;
    this.token_color = '#ce0000';


    // console.log(this.selected_seva_array)
    for (let i = 0; i < this.Special_seva_array.length; i++) {
      //this.Special_seva_array[i].checked = false;

    }


    this.ClearAllFields();


  }

  //Function for Aradhane Segment button click
  selectedAradhane() {
    this.disablesegments();
    this.GetSevadata(3);
    for (let i = 0; i < this.selected_seva_array.length; i++) {
      this.selected_seva_array[i].checked = false;
    }
    // this.selected_seva_array.splice(0);
    // this.selected_seva_array = [];
    // this.selected_seva_array.length = 0;
    this.seva_amount_total = 0;
    this.token_color = '#ce0000';
    // console.log(this.selected_seva_array)
    for (let i = 0; i < this.Aradhane_seva_array.length; i++) {
      //this.Aradhane_seva_array[i].checked = false;

    }

    this.ClearAllFields();

  }
  selectedBuildingFund() {
    this.disablesegments();
    this.GetSevadata(4);
    for (let i = 0; i < this.selected_seva_array.length; i++) {
      this.selected_seva_array[i].checked = false;
    }
    // this.selected_seva_array.splice(0);
    // this.selected_seva_array = [];
    // this.selected_seva_array.length = 0;
    this.seva_amount_total = 0;
    this.token_color = '#ce0000';
    // console.log(this.selected_seva_array)
    for (let i = 0; i < this.Building_seva_array.length; i++) {
      //this.Building_seva_array[i].checked = false;

    }

    this.ClearAllFields();

  }

  selectedShashwathaSeva() {
    this.disablesegments();
    this.GetSevadata(5);
    this.getshashwathasevastandingData();
    for (let i = 0; i < this.selected_seva_array.length; i++) {
      this.selected_seva_array[i].checked = false;
    }
    // this.selected_seva_array.splice(0);
    // this.selected_seva_array = [];
    // this.selected_seva_array.length = 0;
    this.seva_amount_total = 0;
    this.token_color = '#ce0000';
    // console.log(this.selected_seva_array)
    for (let i = 0; i < this.Building_seva_array.length; i++) {
      //this.Building_seva_array[i].checked = false;

    }

    this.ClearAllFields();

  }
   //Function for Aradhane Segment button click
   selectedPratishtapana() {
    this.disablesegments();
    this.GetSevadata(6);
    for (let i = 0; i < this.selected_seva_array.length; i++) {
      this.selected_seva_array[i].checked = false;
    }
    // this.selected_seva_array.splice(0);
    // this.selected_seva_array = [];
    // this.selected_seva_array.length = 0;
    this.seva_amount_total = 0;
    this.token_color = '#ce0000';
    // console.log(this.selected_seva_array)
    for (let i = 0; i < this.Pratishtapana_seva_array.length; i++) {
      //this.Aradhane_seva_array[i].checked = false;

    }

    this.ClearAllFields();

  }

  selectedSiverJubilee() {
    this.disablesegments();
    this.GetSevadata(7);
    for (let i = 0; i < this.selected_seva_array.length; i++) {
      this.selected_seva_array[i].checked = false;
    }
    // this.selected_seva_array.splice(0);
    // this.selected_seva_array = [];
    // this.selected_seva_array.length = 0;
    this.seva_amount_total = 0;
    this.token_color = '#ce0000';
    // console.log(this.selected_seva_array)
    for (let i = 0; i < this.SilverJubilee_seva_array.length; i++) {
      //this.Aradhane_seva_array[i].checked = false;

    }

    this.ClearAllFields();

  }
  getshashwathasevastandingData() {
    this.restProvider.getRecurringSevas().subscribe(
      (result) => {
        console.log(result);
        if (result) {
          this.thithi_array = result.tithi;
          var newrow = new Tithi();
          newrow.name = "None";
          newrow.id = 0;
          this.thithi_array.splice(0, 0, newrow);
          this.shashwatha_nakshatra_array = result.nakshatras;
          var newrownakshatra = new Nakshatra();
          newrownakshatra.name = "None";
          newrownakshatra.id = 0;
          this.shashwatha_nakshatra_array.splice(0, 0, newrownakshatra)
          this.maasa_array = result.maasa;
          // this.thithi_for_shashwathaseva = this.thithi_array[0].name;
          //this.paksha_for_shashwathaseva = this.paksha_array[0].name;
          // this.nakshatra_for_shashwathaseva = this.shashwatha_nakshatra_array[0].name;
          this.maasa_for_shashwathaseva = this.maasa_array[0].name;

          console.log("tithi,paksha,nakshatra,maasa", this.thithi_for_shashwathaseva, this.paksha_for_shashwathaseva, this.nakshatra_for_shashwathaseva, this.maasa_for_shashwathaseva);
        }
      },
      error => {
        console.log(error);
      }
    )
  }

  showShashwathaSevas() {
    this.showshashwathasevas = true;

  }

  setShashwathaSeva(s: Seva) {
    if (s) {
      this.shashwatha_seva = s.sevaname;

      s.checked = true;
      this.PassSelectedSevas(s);
    }
    this.showshashwathasevas = false;


  }

  //Function for cash segment click
  CashSelected() {
    this.cashmode = true;
    this.payment_type = 1;
  }

  //Function for card segment click
  CardSelected() {
    this.cashmode = false;
    this.payment_type = 3;
  }

  //Function for cheque segment click
  ChequeSelected() {
    this.cashmode = false;
    this.payment_type = 2;
  }
  OthersSelected() {
    this.cashmode = false;
    this.payment_type = 5;
  }
  UPISelected() {
    this.cashmode = false;
    this.payment_type = 4;
  }

  //Function to clear seva date
  ClearSevadate() {
    this.seva_date = new Date('2018-08-27').toISOString();//null;
    this.seva_time = "10:00";
  }

  //Function for updating the sava amount value edited by the user
  InputChanged(s, n) {
    // //I am trying something here 2nd October
    console.log("inside blur")
    // console.log(this.seva_amount_edited)
    //  if((this.seva_amount_edited <= 0))

    // {
    //   let alert = this.alertController.create({
    //     title: 'Alert',
    //     subTitle: 'Invalid amount',
    //     buttons: [
    //       {
    //         text: 'Ok',
    //         handler: () => {
    //           console.log('Yes clicked');
    //           this.seva_amount_edited = 0;
    //         }
    //       }
    //     ]
    //   });
    //   alert.present();
    //   return;
    // }
    // for (let i = 0; i < this.selected_seva_array.length; i++) {
    //   let SearchSevaWithZeroAmount = this.selected_seva_array.find((item) => item.sevaamount == 0)

    //   let zeroIndex = this.selected_seva_array.indexOf(SearchSevaWithZeroAmount);
    //   if (zeroIndex > -1) {
    //     console.log("Input changed with selected index")
    //     this.selected_seva_array[zeroIndex].sevaamount = this.seva_amount_edited;
    //     }
    // }
    // this.CalculateTotal();

    //     ///////////trying something here//////////
    console.log(s, n)
    // if(n)
    // {
    //   this.seva_amount_edited = n;
    // }
    let zeroIndex = this.selected_seva_array.indexOf(s);
    if (zeroIndex > -1) {
      console.log("Input changed with selected index")
      this.selected_seva_array[zeroIndex].sevaamount = n;
    }


    this.CalculateTotal();
  }

  //Function for handling selected sevas
  PassSelectedSevas(r) {
    console.log("seva selected:", r)
    this.is_seva_checked = r.checked;
    //   if((r.sevaname == 'Hastodaka') || (r.sevaname == 'Dwadasi Hastodaka') || (r.sevaname == 'Special Hastodaka') || (r.sevaname == 'Hastodaka - Adradhana (Y)'))
    //   {


    //   let alert = this.alertController.create({
    //     title: 'Alert',
    // subTitle: 'Please enter number of extra persons',
    //     inputs: [
    //       {
    //         name: 'extrainput',
    //         placeholder: 'Extra Persons'
    //       },

    //     ],
    //     buttons: [
    //       {
    //         text: 'Cancel',
    //         role: 'cancel',
    //         handler: data => {
    //           console.log('Cancel clicked');
    //         }
    //       },
    //       {
    //         text: 'Ok',
    //         handler: data => {
    //           console.log("username:",data.extrainput)
    //           this.addl_people = data.extrainput;
    //           if(this.addl_people > 0)
    //           {
    //             this.CalculateHasthodakaAmount();
    //           }
    //         }
    //       }
    //     ]
    //   })
    //   alert.present();
    // }
    //Condition when the checkbox is selected (a seva is selected)
    if (this.is_seva_checked === true) {

      let y: Seva = new Seva()

      y.id = r.id
      y.sevaname = r.sevaname
      y.sevacategory = r.sevacategory
      y.sevaamount = r.sevaamount
      y.persons_included = r.personsincluded
      y.itemlist = r.itemlist
      y.tokencolor = r.tokencolor
      y.checked = r.checked
      if(y.sevaamount == 0){
        this.zeroamountadded = true;
      }
      let searchifsevaexsisits = this.selected_seva_array.find(item => item.sevaname == r.sevaname);

      //here I am trying to check whether the user has selected multiple types of hasthodaks
      // let isalreadyhasthodakaselected = this.selected_seva_array.find(item => item.sevaname == "Hastodaka");
      let isalreadyhasthodakaselected: boolean = false;
      for (let i = 0; i < this.selected_seva_array.length; i++) {
        console.log("inside alert")
        let x = r.sevaname;
        // x.replace(/\s/g, "");
        x = x.toUpperCase();
        console.log(x)
        if (x.includes('HASTODAKA'))
        // if((r.sevaname == 'Hastodaka ') || (r.sevaname == 'Dwadasi Hastodaka ') || (r.sevaname == 'Special Hastodaka ') || (r.sevaname == 'Hastodaka - Adradhana (Y)') || (r.sevaname == 'Phalahara Pooje (Hastodaka) ') || (r.sevaname == 'Pakshamasa Hastodaka ') || (r.sevaname == 'Madwanavami Hastodaka '))
        {



          console.log("user selected one of the kinds of hasthodakas")
          let x1 = this.selected_seva_array[i].sevaname.toUpperCase().trim();
          console.log(x1)
          if (x1.includes('HASTODAKA'))
          // if((this.selected_seva_array[i].sevaname == 'Hastodaka ') || (this.selected_seva_array[i].sevaname == 'Dwadasi Hastodaka ') || (this.selected_seva_array[i].sevaname == 'Special Hastodaka ') || (this.selected_seva_array[i].sevaname == 'Hastodaka - Adradhana (Y)') || (this.selected_seva_array[i].sevaname == 'Phalahara Pooje (Hastodaka) ') || (this.selected_seva_array[i].sevaname == 'Pakshamasa Hastodaka ') || (this.selected_seva_array[i].sevaname == 'Madwanavami Hastodaka '))
          {
            console.log("already we have hasthodaka in selected list")
            isalreadyhasthodakaselected = true;
          }
          // else
          // {
          //   isalreadyhasthodakaselected = false;
          // }

        }
      }
      if (isalreadyhasthodakaselected == true) {
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'You cannot  select multiple types of Hastodaks',
          enableBackdropDismiss: false,
          buttons: [
            {
              text: 'Ok',
              handler: () => {
                console.log('Yes clicked');
                r.checked = false;
              }
            }
          ]
        });
        alert.present();
        return;
      }
      //  if((r.sevaname == 'Hastodaka ') || (r.sevaname == 'Dwadasi Hastodaka ') || (r.sevaname == 'Special Hastodaka ') || (r.sevaname == 'Hastodaka - Adradhana (Y) ') || (r.sevaname == 'Phalahara Pooje (Hastodaka) ') || (r.sevaname == 'Pakshamasa Hastodaka ') || (r.sevaname == 'Madwanavami Hastodaka ') && (isalreadyhasthodakaselected == false))
      let find_key_for_hasthodaka = r.sevaname.toUpperCase();
      console.log("came here")
      if ((find_key_for_hasthodaka.includes('HASTODAKA'))) {
        console.log("seva contains hasthodaka text");
        let alert1 = this.alertController.create({
          title: 'Alert',
          subTitle: 'Please enter number of persons',
          enableBackdropDismiss: false,
          inputs: [
            {
              name: 'addl_people',
              placeholder: 'Extra Persons',
              type: 'number',
              min: '1',
              value: "1",
              //step:'1'

            },

          ],
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              handler: data => {
                console.log('Cancel clicked');
                r.checked = false;
              }
            },
            {
              text: 'Ok',
              handler: data => {
                console.log("username:", data.extrainput)
                this.addl_people = parseInt(data.addl_people);

                console.log(typeof (this.addl_people))
                console.log("addl_ppl inside popup", this.addl_people);
                if ((this.addl_people % 1 != 0) || (this.addl_people < 0) || (typeof (this.addl_people) != "number")) {
                  let alert2 = this.alertController.create({
                    title: 'Alert',
                    subTitle: 'Invalid amount',
                    enableBackdropDismiss: false,
                    buttons: [
                      {
                        text: 'Ok',
                        handler: () => {
                          console.log('Yes clicked');
                          this.addl_people = null;


                        }
                      }
                    ]
                  });

                  alert2.present();
                  return;
                }

                if (this.addl_people > 0) {
                  console.log("passing to calculateHasthodakaAmount()");
                  this.CalculateHasthodakaAmount();
                  //this.addl_people = 0; //bug fix-16/2/2019(bug-addl_ppl not reseting after deselection of hasthodaka)
                }
              }
            }
          ]
        })
        alert1.present();
      }





      //here I am trying to check whether the user has selected multiple types of shradha
      //  let isalreadyshradhaselected = this.selected_seva_array.find(item => item.sevaname == "Chataka Shradha");
      //  console.log("Hasthodaka selected")
      //  if(isalreadyshradhaselected)
      //  {
      //    console.log("already hastodaka selected")
      //    console.log("now the selected seva is ",y)
      //    if((y.sevaname == "Chataka Shradha") || (y.sevaname == "Sankalpa Shradha") || (y.sevaname == "Pakshamasa Chataka Shradha") || (y.sevaname == "Pakshamasa Sankalpa Shradha"))
      //    {

      //      let alert = this.alertController.create({
      //        title: 'Alert',
      //        subTitle: 'You cannot  select multiple types of Shradhas',
      //        buttons: [
      //          {
      //            text: 'Ok',
      //            handler: () => {
      //              console.log('Yes clicked');
      //              r.checked = false;
      //            }
      //          }
      //        ]
      //      });
      //      alert.present();
      //      return;
      //    }
      //  }

      let isalreadyshradhaselected: boolean = false;
      for (let i = 0; i < this.selected_seva_array.length; i++) {
        let s = r.sevaname.toUpperCase();
        if (s.includes('SHRADDHA'))
        // if((r.sevaname == "Chataka Shradha ") || (r.sevaname == "Sankalpa Shradha ") || (r.sevaname == "Pakshamasa Chataka Shraddha ") || (r.sevaname == "Pakshamasa Sankalpa Shraddha "))
        {
          let s1 = this.selected_seva_array[i].sevaname.toUpperCase();
          if (s1.includes('SHRADDHA'))
          // if((this.selected_seva_array[i].sevaname == "Chataka Shradha ") || (this.selected_seva_array[i].sevaname == "Sankalpa Shradha ") || (this.selected_seva_array[i].sevaname == "Pakshamasa Chataka Shraddha ") || (this.selected_seva_array[i].sevaname == "Pakshamasa Sankalpa Shraddha "))
          {
            isalreadyshradhaselected = true;
          }
          else {
            isalreadyshradhaselected = false;
          }
          if (isalreadyshradhaselected == true) {
            let alert = this.alertController.create({
              title: 'Alert',
              subTitle: 'You cannot  select multiple types of Shradhas',
              enableBackdropDismiss: false,
              buttons: [
                {
                  text: 'Ok',
                  handler: () => {
                    console.log('Yes clicked');
                    r.checked = false;
                  }
                }
              ]
            });
            alert.present();
            return;
          }
        }
      }




      if (searchifsevaexsisits) {

      } else {
        let m = y.sevaname.toUpperCase();
        if (m.includes('HASTODAKA')) {
          y.persons_included = this.addl_people;
        }
        if (this.stype == 'shashwathaseva' && this.selected_seva_array.length >= 1) {
          this.selected_seva_array.pop();
        }

        this.selected_seva_array.push(y);
      }

      console.log("seva added", y);

      for (let i = 0; i < this.selected_seva_array.length; i++) {

        //  if(this.selected_seva_array[i].sevaamount > 0)
        // {
        //this.seva_amount_edited = this.selected_seva_array[i].sevaamount;
        //this.seva_list_amount = this.selected_seva_array[i].sevaamount;
        // }
        // if(this.selected_seva_array[i].persons_included > 0)
        // {
        //this.seva_persons_edited = this.selected_seva_array[i].personsincluded;

        // }
        // this.tokensum = 0;
        //   this.tokensum = +(+this.tokensum)+  +  +(+this.selected_seva_array[i].personsincluded);
        //   this.updateEndToken();

        // if(this.token_numbersfrom > 0)
        // {
        //   //this.tokensum = +(+this.tokensum)+  +  +(+this.selected_seva_array[i].personsincluded);
        //   this.token_numbersto = this.token_numbersfrom + this.tokensum;
        // }
        console.log("personstype:", typeof (this.selected_seva_array[i].persons_included))

      }

      //console.log(this.seva_amount_edited)
      //this.seva_amount_total = (+ this.seva_amount_total) + (+ this.seva_list_amount);
      // this.seva_amount_total = (+ this.seva_amount_total) + (+ this.seva_amount_edited);
      //this.AddHasthodakaExtraAmount(); /////  //comented 25/2/2019AR
      this.CalculateTotal();



    }

    //condition when checkbox is deselected(a seva is deselected)
    else if (this.is_seva_checked === false) {
      if(r.sevaamount == 0){
        this.zeroamountadded = false;
      }
      this.seva_amount_edited = 0; //added for bug fix-15/2/2019 (bug-sevaamount retaining after deselcting the seva(seva with amount zero))

      let serchselectedsevaarray = this.selected_seva_array.find(item => item.id == r.id);


      let index = this.selected_seva_array.indexOf(serchselectedsevaarray);

      console.log("seva_amount for deselected seva index", this.selected_seva_array);
      console.log("seva_amount for deselected seva index", index);
      console.log(index)
      if (index > -1) {
        this.deselected_seva_amount = this.selected_seva_array[index].sevaamount;
        if (this.deselected_seva_amount == 0) {
          console.log("this.seva_amount_edited:", this.seva_amount_edited)
          console.log("this.deselected_seva_amount:", this.deselected_seva_amount);
        }


        this.seva_amount_total = (+ this.seva_amount_total) - (+ this.seva_list_amount);
        this.selected_seva_array.splice(index, 1);
        console.log("seva_amount for deselected seva index delete", this.selected_seva_array);
        let y = serchselectedsevaarray.sevaname.toUpperCase();
        if (y.includes('HASTODAKA'))
        // if((serchselectedsevaarray.sevaname == 'Hastodaka ') || (serchselectedsevaarray.sevaname == 'Dwadasi Hastodaka ') || (serchselectedsevaarray.sevaname == 'Special Hastodaka ') || (serchselectedsevaarray.sevaname == 'Hastodaka - Adradhana (Y) ') || (serchselectedsevaarray.sevaname == 'Phalahara Pooje (Hastodaka) ') || (serchselectedsevaarray.sevaname == 'Pakshamasa Hastodaka ') || (serchselectedsevaarray.sevaname == 'Madwanavami Hastodaka '))
        {
          console.log("serchselectedsevaarray.personsincluded", serchselectedsevaarray.persons_included)
          serchselectedsevaarray.persons_included = 0;

        }
        this.updateEndToken();
        this.CalculateTotal();
      }
    }
    // console.log("Sevas selected from the list:", this.selected_seva_array);

    //condition for checking the number of sevas selected
    if (this.selected_seva_array.length > 4) {
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Upto four sevas can be selected at a time',
        enableBackdropDismiss: false,
        buttons: [
          {
            text: 'Ok',
            handler: () => {
              console.log('Yes clicked');
              r.checked = false;
            }
          }
        ]
      });
      alert.present();
      let index = this.selected_seva_array.indexOf(r);
      console.log(index)
      if (index > -1) {
        this.seva_amount_edited = this.selected_seva_array[index].sevaamount;
        // console.log("seva_amount for deselected seva", this.seva_list_amount);
        this.CalculateTotal();
        // this.seva_amount_total = (+ this.seva_amount_total) - (+ this.seva_list_amount);
        this.selected_seva_array.splice(index, 1);
        this.CalculateTotal();
      }
    }
  }

  CalculateTotal() {
    console.log("inside total")
    this.seva_amount_total = 0;
    this.seva_list_amount = 0;


    for (let i = 0; i < this.selected_seva_array.length; i++) {
      this.seva_list_amount = (+this.selected_seva_array[i].sevaamount);
      this.seva_amount_total = +(+ this.seva_amount_total) + +(+ this.seva_list_amount);
      this.updateEndToken();



    }

    //this.seva_amount_total = +((+ this.seva_amount_total) + +(+ this.seva_list_amount) +  +(+this.seva_amount_edited)) - +((+this.deselected_seva_amount));
    // console.log("listamount",this.seva_list_amount);
    //  console.log("deselectedamt",this.deselected_seva_amount);
    //this.seva_amount_total = +(+ this.seva_amount_total) + +(+ this.seva_list_amount) +  +(+this.seva_amount_edited) - +(+this.deselected_seva_amount);

    if (this.seva_amount_edited > 0) {
      //  console.log("inside edit section")
      //  console.log("this.seva_amount_total",this.seva_amount_total);
      //  console.log("this.seva_amount_edited",this.seva_amount_edited);
      // this.seva_amount_total = +(+ this.seva_amount_total) + +(+this.seva_amount_edited);   //commented 2nd October
    }
    if (this.deselected_seva_amount > 0) {

      // console.log("inside deseletcion section")
      // console.log("this.seva_amount_total",this.seva_amount_total);
      // console.log("this.deselected_seva_amount",this.deselected_seva_amount);
      // this.seva_amount_total = (+(+ this.seva_amount_total) - (+this.seva_amount_edited));    //commented 2nd october
      //this.seva_amount_total = (+(+ this.seva_amount_total) + +(+ this.seva_list_amount))  -  (+this.deselected_seva_amount);
      // this.deselected_seva_amount = 0;
    }
    this.deselected_seva_amount = 0;



    //     console.log(this.seva_amount_total);

    //     console.log(this.seva_amount_edited);
    //     this.seva_amount_total = (+ this.seva_amount_total)  + (+ this.seva_list_amount) + (+this.seva_amount_edited);




  }

  //Function for handling hastodaka seva
  AddHasthodakaExtraAmount() {

    //condition to check whether there are any additional people
    if ((this.addl_people > 0) && (this.selected_seva_array.length >= 0 && this.selected_seva_array.length < 5)) {
      //Searching for normal hastodaka in the already selected seva list
      let searchForHasthodaka = this.Regular_seva_array.find(item => item.sevaname == 'Hastodaka ');
      let searchForDwadasiHasthodaka = this.Regular_seva_array.find(item => item.sevaname == 'Dwadasi Hastodaka ');
      let searchForHasthodakaAdradana = this.Aradhane_seva_array.find(item => item.sevaname == 'Hastodaka - Adradhana (Y) ');

      let serchselectedsevaarray = this.selected_seva_array.find(item => item.sevaname == 'Hastodaka');
      let searchForDwadasiHasthodaka_local = this.selected_seva_array.find(item => item.sevaname == 'Dwadasi Hastodaka ');
      let searchForHasthodakaAdradana_local = this.selected_seva_array.find(item => item.sevaname == 'Hastodaka - Adradhana (Y) ');

      // let searchForHasthodaka = this.Regular_seva_array.find(item => item.sevaname.toUpperCase().search('HASTODAKA') == 1);
      // let searchForDwadasiHasthodaka =
      // this.Regular_seva_array.find(item => item.sevaname == 'Dwadasi Hastodaka');
      // let searchForHasthodakaAdradana = this.Regular_seva_array.find(item => item.sevaname == 'Hastodaka - Adradhana (Y)');

      //if it exists
      if (serchselectedsevaarray) {
        // console.log(searchForHasthodaka.sevaamount);
        this.seva_amount_total = (+this.seva_amount_total) - (+serchselectedsevaarray.sevaamount);
        let hastodoka_amt_for_addlppl = ((+searchForHasthodaka.sevaamount) * (+this.addl_people));
        // console.log(hastodoka_amt_for_addlppl);
        serchselectedsevaarray.sevaamount = hastodoka_amt_for_addlppl;
        this.seva_amount_total = (+this.seva_amount_total) + (+searchForHasthodaka.sevaamount);
      }
      else if (searchForDwadasiHasthodaka_local) {
        // console.log(searchForDwadasiHasthodaka.sevaamount);
        this.seva_amount_total = (+this.seva_amount_total) - (+searchForDwadasiHasthodaka_local.sevaamount);

        let Dwadasihastodoka_amt_for_addlppl = ((+searchForDwadasiHasthodaka.sevaamount) * (+this.addl_people));
        // console.log(Dwadasihastodoka_amt_for_addlppl);
        searchForDwadasiHasthodaka_local.sevaamount = Dwadasihastodoka_amt_for_addlppl;
        this.seva_amount_total = (+this.seva_amount_total) + (+searchForDwadasiHasthodaka_local.sevaamount);
      }
      else if (searchForHasthodakaAdradana_local) {
        // console.log(searchForDwadasiHasthodaka.sevaamount);
        this.seva_amount_total = (+this.seva_amount_total) - (+searchForHasthodakaAdradana_local.sevaamount);

        let hastodokaAdrdana_amt_for_addlppl = ((+searchForHasthodakaAdradana.sevaamount) * (+this.addl_people));
        // console.log(Dwadasihastodoka_amt_for_addlppl);
        searchForHasthodakaAdradana_local.sevaamount = hastodokaAdrdana_amt_for_addlppl;
        this.seva_amount_total = (+this.seva_amount_total) + (+searchForHasthodakaAdradana_local.sevaamount);
      }
      else {
        //let add_hastodaka_row = this.Regular_seva_array.find(item => item.sevaname == "Hastodaka");
        let add_hastodaka_row: Seva = new Seva()

        let y: Seva = new Seva()

        let searchForHasthodakaAdradana = this.Aradhane_seva_array.find(item => item.sevaname == 'Hastodaka - Adradhana (Y) ');

        searchForHasthodakaAdradana.checked = true;

        // let abc = this.Regular_seva_array.find(item => item.sevaname == "Hastodaka");

        console.log("2 add_hastodaka_row before abc", searchForHasthodakaAdradana)

        if (searchForHasthodakaAdradana) {
          y.id = searchForHasthodakaAdradana.id
          add_hastodaka_row.id = searchForHasthodakaAdradana.id
          add_hastodaka_row.sevaname = searchForHasthodakaAdradana.sevaname
          add_hastodaka_row.sevacategory = searchForHasthodakaAdradana.sevacategory
          add_hastodaka_row.sevaamount = searchForHasthodakaAdradana.sevaamount
          add_hastodaka_row.persons_included = searchForHasthodakaAdradana.persons_included
          add_hastodaka_row.itemlist = searchForHasthodakaAdradana.itemlist
          add_hastodaka_row.tokencolor = searchForHasthodakaAdradana.tokencolor
          add_hastodaka_row.checked = searchForHasthodakaAdradana.checked
        }
        //I commented below lines of code because it was adding hasthodaka adradhana to selected seva list-AR 17/1/2019
        // if (add_hastodaka_row) {


        //   this.selected_seva_array.push(add_hastodaka_row);
        //   //this.seva_amount_total = (+this.seva_amount_total) - (+add_hastodaka_row.seva_amount);

        //   let hastodoka_amt_for_addlppl = ((+add_hastodaka_row.sevaamount) * (+this.addl_people));
        //   // console.log(hastodoka_amt_for_addlppl);
        //   add_hastodaka_row.sevaamount = hastodoka_amt_for_addlppl;
        //   this.seva_amount_total = (+this.seva_amount_total) + (+add_hastodaka_row.sevaamount);

        // }
      }
    }
  }

  //Function for confirm  button click
  onConfirm() {

    console.log("addl_ppl inside confirm", this.addl_people);
    var ishastodakasevthere = false

    if (Number(this.addl_people) > 0) {
      var foundhasthodaka = false;
      // let searchForHasthodakaAdradana_local = this.selected_seva_array.find(item => item.sevaname == 'Hastodaka - Adradhana (Y)');
      //let searchForHasthodakaAdradana_local = this.selected_seva_array.find((item => item.sevaname == 'Hastodaka') || (item => item.sevaname == 'Dwadasi Hastodaka'));
      //let index = this.selected_seva_array.indexOf(searchForHasthodakaAdradana_local);
      // if (index < 0) {
      //Please select the Aradhane Hastodaka

      for (let i = 0; i < this.selected_seva_array.length; i++) {
        let g = this.selected_seva_array[i].sevaname.toUpperCase();
        if (g.includes('HASTODAKA'))
        //  if((this.selected_seva_array[i].sevaname == 'Hastodaka ') || (this.selected_seva_array[i].sevaname == 'Dwadasi Hastodaka ') || (this.selected_seva_array[i].sevaname == 'Special Hastodaka ') || (this.selected_seva_array[i].sevaname == 'Hastodaka - Adradhana (Y) ')|| (this.selected_seva_array[i].sevaname == 'Phalahara Pooje (Hastodaka) ') || (this.selected_seva_array[i].sevaname == 'Pakshamasa Hastodaka ') || (this.selected_seva_array[i].sevaname == 'Madwanavami Hastodaka '))
        {
          console.log("came inside of hasthodaka present condition")
          foundhasthodaka = true;
        }
        // else
        // {
        //    foundhasthodaka = false;
        // }
      }
      console.log("foundhasthodaka", foundhasthodaka)
      // if(foundhasthodaka == false)
      // {
      //   let alert = this.alertController.create({
      //     title: 'Alert',
      //     subTitle: 'Please select Hastodaka seva',
      //     cssClass: 'buttonCsstext',
      //     buttons: [
      //       {
      //         text: 'Ok',
      //         cssClass: 'buttonCss',
      //         role: 'cancel',
      //         handler: () => {
      //         }
      //       }
      //     ]
      //   });

      //   alert.present();
      //   return
      // }

      // }   //end of if(index) condition
    }


    //this.AddHasthodakaExtraAmount(); //commented 25/2/2019AR
    this.CalculateTotal();
    // this.restProvider.getreport().subscribe(data => saveAs(data, 'pdfreport.pdf'));

    if (this.selected_seva_array.length == 0) {
      console.log("inside zero seva selection case", this.selected_seva_array.length)
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Atleast one seva should be selected before booking',
        enableBackdropDismiss: false,
        cssClass: 'buttonCsstext',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();
      return
    }
    for (let i = 0; i < this.selected_seva_array.length; i++) {
      console.log("came inside for loop")
      console.log(this.selected_seva_array[i].sevaamount)
      let x = this.selected_seva_array.find((item) => { return item.sevaamount == 0 })
      if (x) {
        console.log("found an item with zero amount")
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'You have a seva with zero amount,please change the amount before booking',
          enableBackdropDismiss: false,
          cssClass: 'buttonCsstext',
          buttons: [
            {
              text: 'Ok',
              cssClass: 'buttonCss',
              role: 'cancel',
              handler: () => {
              }
            }
          ]
        });

        alert.present();

        return
      }
    }
    if ((this.selected_seva_array.length > 0) && (this.payment_type == null)) {
      console.log("inside zero seva selection case", this.selected_seva_array.length)
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Payment type should be selected before booking',
        enableBackdropDismiss: false,
        cssClass: 'buttonCsstext',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();
      return
    }
    if (((this.payment_type == 2) || (this.payment_type == 3) || (this.payment_type == 4)) && (this.Account_detail == null || this.Account_detail == ' ')) {

      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Card number not provided/Cheque number not provided',
        enableBackdropDismiss: false,
        cssClass: 'buttonCsstext',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();
      return
    }

    if ((this.mobile_number == null) || (this.name == null) || (this.seva_date == null)) {
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'All user details are mandatory for booking',
        enableBackdropDismiss: false,
        cssClass: 'buttonCsstext',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

      return
    }

    // this.navCtrl.push(PdfPage);
    let alert = this.alertController.create({
      title: 'Alert',

      subTitle: 'Are you sure you want to confirm booking?',
      enableBackdropDismiss: false,
      cssClass: 'buttonCss',
      buttons: [
        {
          text: 'No',
          cssClass: 'nobutton',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');


          }
        },
        {
          text: 'Yes',
          cssClass: 'yesbutton',
          handler: () => {
            console.log('Yes clicked', this.mobile_number, this.name, this.gotra, this.seva_date);
            //  || (this.token_numbers == null) || (this.nakshatra == null)






            // this.AddHasthodakaExtraAmount();
            // this.CalculateTotal();
            if(localStorage.getItem("recieptdata")){
              localStorage.removeItem("recieptdata");
            }
	    if (this.veda == null){
	    	this.veda = "";
		}
            this.postseva = new PostSevaBooking();
            this.postseva.seva = [];
            //here posting must be done
            //Before calling the post method we should set the values to  object of postSevaBooking class(class is defined under models->PostSevaBooking)
            this.postseva.phone = this.mobile_number;
            this.postseva.name = this.name;
            this.postseva.gotra = this.gotra;
            this.postseva.emailid = this.emailid;
            this.postseva.nakshatra = this.nakshatra;
            this.postseva.veda = this.veda.substring(0,1).toUpperCase();
            this.postseva.numpersons = (this.addl_people) ? this.addl_people : 0; //set just for testing
            this.postseva.amountpaid = this.seva_amount_total; //set to total assuming full amount is paid
            this.postseva.amountpending = 0; //assuming no balence amount
            this.postseva.amounttotal = this.seva_amount_total;
            this.postseva.paymenttype = this.payment_type;
            this.postseva.paymentnote = this.Account_detail;
            this.postseva.specialrequest = this.sp_request;
            this.postseva.other_charges = 0; //just for testing
            let starthours: any;
            console.log("seva time", this.seva_time)
            if (this.seva_time) {
              starthours = this.seva_time.split(':');
              let start_am_pm: any;
              let end_am_pm: any;
              if (starthours[0] > 12) {
                start_am_pm = "PM";
                this.seva_time = this.seva_time + ' ' + start_am_pm;
              }
              else {
                start_am_pm = "AM";
                this.seva_time = this.seva_time + ' ' + start_am_pm
              }
              //  if(starthours[0] > 12)
              //  {
              //    starthours[0] = starthours[0] % 12 || 12;
              //    console.log("starthours",starthours)
              //    this.seva_time.split(':')
              //  }
              this.postseva.reporting_time = this.seva_time;
              console.log("seva time", this.seva_time)
              //console.log(starthours[0]);

              this.postseva.reporting_time = this.seva_time;
            }

            //for testing
            console.log("this.postseva.reporting_time", this.postseva.reporting_time)
            this.postseva.seva_time = this.seva_time;
            console.log(this.token_numbersfrom, this.token_numbersfrom)
            if (this.stype == 'regular' || this.stype == 'special') {
              this.postseva.tokendetails = ((this.token_numbersfrom && this.token_numbersto)) ? (this.token_numbersfrom + '-' + this.token_numbersto) : (' ');
            }
            if (this.stype == 'aradhane' || this.stype == 'buildingfund' || this.stype == 'pratishtapana') {
              console.log(this.token_numbers)
              this.postseva.tokendetails = ((this.token_numbers) ? (this.token_numbers + ' ') : (' '));
            }


            this.postseva.bookingtype = "M";

            this.postseva.date = this.datePipe.transform(this.calander_details.date, "yyyy-MM-dd");

            //console.log(this.datePipe.transform(date,"yyyy-MM-dd"));


            // console.log("Before population", this.postseva.seva, this.selected_seva_array);
            for (let i = 0; i < this.selected_seva_array.length; i++) {
              // console.log("Loop", i);
              // let searchForsevaID = this.seva_array.find(item => item.sevaname == this.selected_seva_array[i].sevaname);
              let searchForsevaID = ((this.Regular_seva_array.find(item => item.sevaname == this.selected_seva_array[i].sevaname)) || (this.Special_seva_array.find(item => item.sevaname == this.selected_seva_array[i].sevaname)) || (this.Aradhane_seva_array.find(item => item.sevaname == this.selected_seva_array[i].sevaname)) || (this.Building_seva_array.find(item => item.sevaname == this.selected_seva_array[i].sevaname)) || (this.Pratishtapana_seva_array.find(item => item.sevaname == this.selected_seva_array[i].sevaname))|| (this.SilverJubilee_seva_array.find(item => item.sevaname == this.selected_seva_array[i].sevaname)));

              console.log("searchForsevaID", searchForsevaID);

              this.selected_seva_array[i].id = searchForsevaID.id

              let local_instance: SevalistforBooking = new SevalistforBooking

              local_instance.id = searchForsevaID.id
              local_instance.quantity = 1

              // if (this.selected_seva_array[i].sevaamount == 0){
              //   local_instance.amount = this.seva_amount_edited;
              // }

              //I changed the code 2nd october
              local_instance.amount = this.selected_seva_array[i].sevaamount;

              // if (this.selected_seva_array[i].personsincluded == 0) {
              //   local_instance.quantity = 1
              // }
              console.log("addl_ppl", this.addl_people);
              let abc = this.selected_seva_array[i].sevaname.toUpperCase()
              var str = "HASTODAKA";

              if (abc.search(str) == -1) {
                console.log("inside -1 case")
                if (this.selected_seva_array[i].persons_included > 0) {
                  local_instance.quantity = 1;

                }
              } else {
                //if (this.addl_people > 0) {
                console.log(this.postseva.numpersons)
                if (this.postseva.numpersons > 0) {
                  console.log("addl_ppl", this.addl_people);
                  local_instance.quantity = Number(this.addl_people);

                }
              }

              this.seva_seleced_list.push(local_instance)
              this.CalculateTotal();

            }
            // console.log("After population", this.postseva.seva, this.selected_seva_array);
            // console.log(this.seva_seleced_list);
            this.postseva.seva = this.seva_seleced_list; // this has to clarified with NGV Sir.For now set it to empty array
            console.log("Seva Data before posting:", this.postseva)

            //calling post method from restprovider
            this.restProvider.postSevaBooking(this.postseva)
              .subscribe(
                (result) => {
                  console.log("Result from postmethod:", result);

                  let instance: SevaBookingResponse = result["data"];
                  // console.log("Result from instance", instance);

                  // console.log("Result from result.id:", instance.id);

                  //NEED TO GET THE VALUE OF THE RECEIPT NO HERE
                  localStorage.setItem("recieptdata",JSON.stringify(instance));
                  let rectno: string = String(instance.id)
                  console.log("rectno passed to show the pdf after booking:", rectno)
                  this.restProvider.downloadPDF(rectno).subscribe(
                    (res) => {

                      console.log('res', res);
                      var fileURL = URL.createObjectURL(res);
                      console.log(fileURL)
                      this.ClearAllFields();
                      let alert = this.alertController.create({
                        title: 'Alert',
                        subTitle: 'Receipt generated with receipt number ' +instance.receiptno,
                        enableBackdropDismiss: false,
                        cssClass: 'buttonCsstext',
                        buttons: [
                          {
                            text: 'Ok',
                            cssClass: 'buttonCss',
                            role: 'cancel',
                            handler: () => {
                              this.navCtrl.push(CalanderPage);
                               window.open(fileURL);
                            }
                          }
                        ]
                      });
    
                      alert.present();
                      
                    }
                  );
                },
                error => {
                  console.log(error.statusText);
                  console.log(error);
                  let alert = this.alertController.create({
                    title: 'Alert',
                    subTitle: 'Seva booking unsuccessful',
                    enableBackdropDismiss: false,
                    cssClass: 'buttonCsstext',
                    buttons: [
                      {
                        text: 'Ok',
                        cssClass: 'buttonCss',
                        role: 'cancel',
                        handler: () => {
                          this.ClearAllFields();
                        }
                      }
                    ]
                  });

                  alert.present();

                  return

                }
              )
            if (this.selected_seva_array.length > 0) {
              //setting color for the token based on seva with highest amount
              var t = [];
              for (let i = 0; i < this.selected_seva_array.length; i++) {
                t.push(this.selected_seva_array[i].sevaamount);
              }
              console.log(t)
              this.temp = Math.max(...t);
              let temp1 = this.selected_seva_array.find((item) => item.sevaamount == this.temp);
              console.log(this.temp)
              console.log("item with highest sevaamount", temp1)
              if (temp1.tokencolor == null) {
                this.token_color = '#ce0000';
              }
              else {
                this.token_color = temp1.tokencolor;
              }
            }


            for (let i = 0; i < this.selected_seva_array.length; i++) {
              this.selected_seva_array[i].checked = false;
            }
            this.selected_seva_array.splice(0);


          }
        }
      ]
    });

    alert.present();

    // console.log("selected seva array after confirm",this.selected_seva_array);





  }

  //Function for clearing all the fields
  ClearAllFields() {
    // this.mobile_number = null;
    // this.name = null;
    // this.gotra = null;
    // this.nakshatra = null;
    //this.seva_date = new Date('2018-08-27').toISOString();
    this.seva_time = "10:00";
    // this.seva_time = null;
    this.token_numbers = null;
    this.token_numbersfrom = null;
    this.token_numbersto = null;
    this.addl_people = null;
    this.sp_request = null;
    this.Account_detail = null;
    this.payment_type = null;
    // this.temp_date = null;
    // this.seva_day = null;
    // this.seva_year = null;
    // this.seva_month = null;
    // this.seva_samvatsara = null;
    // this.seva_masa = null;
    // this.seva_paksha = null;
    // this.seva_thithi = null;
    // this.seva_shradda_thithi = null;
    this.token_color = '#ce0000';
    for (let i = 0; i < this.selected_seva_array.length; i++) {
      this.selected_seva_array[i].checked = false;
    }
    for (let i = 0; i < this.Regular_seva_array.length; i++) {
      this.Regular_seva_array[i].checked = false;
    }
    for (let i = 0; i < this.Special_seva_array.length; i++) {
      this.Special_seva_array[i].checked = false;
    }
    for (let i = 0; i < this.Aradhane_seva_array.length; i++) {
      this.Aradhane_seva_array[i].checked = false;
    }
    for (let i = 0; i < this.Building_seva_array.length; i++) {
      this.Building_seva_array[i].checked = false;
    }
    for (let i = 0; i < this.Pratishtapana_seva_array.length; i++) {
      this.Pratishtapana_seva_array[i].checked = false;
    }
    this.selected_seva_array.splice(0);
    this.selected_seva_array = [];
    this.seva_seleced_list = [];
    this.selected_seva_array.length = 0;
    this.seva_amount_edited = 0;
    this.seva_list_amount = 0;
    this.deselected_seva_amount = 0;
    this.seva_amount_total = 0;
    this.ctype = "cash"; //Reset to cash
    //this.payment_type = 1; //Reset to cash
    this.show_gotra_array = false;
    this.show_nakshatra_array = false;
    this.show_user_list = false;
    this.showshashwathasevas = false;
    this.showthithis = false;
    this.showweekdays = false;
    this.shownakshatra = false;
    this.showmaasa = false;
    this.zeroamountadded = false;
    if (this.shashwatha_seva_array.length > 0) {
      this.shashwatha_seva = this.shashwatha_seva_array[0].sevaname;
    }
    if (this.maasa_array.length > 0) {
      this.maasa_for_shashwathaseva = this.maasa_array[0].name;
    }
    if (this.thithi_array.length > 0) {
      this.thithi_for_shashwathaseva = this.thithi_array[0].name;
    }
    if (this.shashwatha_nakshatra_array.length > 0) {
      this.nakshatra_for_shashwathaseva = this.shashwatha_nakshatra_array[0].name;
    }
    this.fromdate = new Date();
    this.fromdate = this.datePipe.transform(this.fromdate, "yyyy-MM-dd");
    this.todate = new Date();
    this.todate = this.datePipe.transform(this.todate, "yyyy-MM-dd");
    this.shashwathasevadate = new Date();
    this.shashwathasevadate = this.datePipe.transform(this.shashwathasevadate, "yyyy-MM-dd");

    //this.navCtrl.push(CalanderPage);
  }
  ClearAndGoBack() {
    //this.mobile_number = null;
    //this.name = null;
    //this.gotra = null;
    //this.nakshatra = null;
    //this.seva_date = new Date('2018-08-27').toISOString();
    this.seva_time = "10:00";
    // this.seva_time = null;
    this.token_numbers = null;
    this.token_numbersfrom = null;
    this.token_numbersto = null;
    this.addl_people = null;
    this.sp_request = null;
    this.Account_detail = null;
    //this.temp_date = null;
    //this.seva_day = null;
    //this.seva_year = null;
    //this.seva_month = null;
    //this.seva_samvatsara = null;
    //this.seva_masa = null;
    //this.seva_paksha = null;
    //this.seva_thithi = null;
    //this.seva_shradda_thithi = null;
    this.token_color = '#ce0000';
    for (let i = 0; i < this.selected_seva_array.length; i++) {
      this.selected_seva_array[i].checked = false;
    }
    // for (let i = 0; i < this.seva_array.length; i++) {
    //   this.seva_array[i].checked = false;
    // }
    for (let i = 0; i < this.Regular_seva_array.length; i++) {
      this.Regular_seva_array[i].checked = false;
    }
    for (let i = 0; i < this.Special_seva_array.length; i++) {
      this.Special_seva_array[i].checked = false;
    }
    for (let i = 0; i < this.Aradhane_seva_array.length; i++) {
      this.Aradhane_seva_array[i].checked = false;
    }
    for (let i = 0; i < this.Building_seva_array.length; i++) {
      this.Building_seva_array[i].checked = false;
    }
    for (let i = 0; i < this.Pratishtapana_seva_array.length; i++) {
      this.Pratishtapana_seva_array[i].checked = false;
    }
    this.selected_seva_array.splice(0);
    this.selected_seva_array = [];
    this.seva_seleced_list = [];
    this.selected_seva_array.length = 0;
    this.seva_amount_edited = 0;
    this.seva_list_amount = 0;
    this.deselected_seva_amount = 0;
    this.seva_amount_total = 0;
    this.ctype = "cash"; //Reset to cash
    this.payment_type = null; //Reset to cash
    this.show_gotra_array = false;
    this.show_nakshatra_array = false;
    this.show_user_list = false;
    this.tokensum = 0;
    this.showshashwathasevas = false;
    this.showthithis = false;
    this.showweekdays = false;
    this.shownakshatra = false;
    this.showmaasa = false;
    if (this.shashwatha_seva_array) {
      this.shashwatha_seva = this.shashwatha_seva_array[0].sevaname;
    }
    if (this.maasa_array) {
      this.maasa_for_shashwathaseva = this.maasa_array[0].name;
    }
    if (this.thithi_array) {
      this.thithi_for_shashwathaseva = this.thithi_array[0].name;
    }
    if (this.shashwatha_nakshatra_array) {
      this.nakshatra_for_shashwathaseva = this.shashwatha_nakshatra_array[0].name;
    }
    this.fromdate = new Date();
    this.fromdate = this.datePipe.transform(this.fromdate, "yyyy-MM-dd");
    this.todate = new Date();
    this.todate = this.datePipe.transform(this.todate, "yyyy-MM-dd");
    this.shashwathasevadate = new Date();
    this.shashwathasevadate = this.datePipe.transform(this.shashwathasevadate, "yyyy-MM-dd");
    //this.navCtrl.push(CalanderPage);
  }

  //Function for log out
  Logout() {
    let alert = this.alertController.create({
      title: 'Alert',
      subTitle: 'Are you sure you want to Logout?',
      enableBackdropDismiss: false,
      cssClass: 'buttonCsstext',
      buttons: [
        {
          text: 'No',
          cssClass: 'buttonCss',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Yes',
          cssClass: 'buttonCss',
          handler: () => {
            console.log('Yes clicked');
            // if (localStorage.getItem('token')) {
            //   localStorage.removeItem('token');
            // }

            //clearing all local storage data
            localStorage.clear();
            this.appCtrl.getRootNav().setRoot(HomePage);
          }
        }
      ]
    });

    alert.present();

  }

  AddPeople() {

    if (Number(this.addl_people) == 0) {
      let searchForHasthodakaAdradana = this.Aradhane_seva_array.find(item => item.sevaname == 'Hastodaka - Adradhana (Y)');
      searchForHasthodakaAdradana.checked = false;

      let searchForHasthodakaAdradana_local = this.selected_seva_array.find(item => item.sevaname == 'Hastodaka - Adradhana (Y)');
      let index = this.selected_seva_array.indexOf(searchForHasthodakaAdradana_local);
      this.selected_seva_array.splice(index, 1);

    }
    this.AddHasthodakaExtraAmount();
    this.CalculateTotal();

  }

  ShowPaymentDropDown() {
    let actionSheet = this.actionSheetCtrl.create({
      cssClass: 'asheet',
      buttons: [
        {

          text: 'CASH',

          handler: () => {
            console.log('cash clicked');
            this.payment_type = 1;
          }
        },
        {
          text: 'CARD',
          handler: () => {
            console.log('card clicked');
            this.payment_type = 3;
          }
        },
        {
          text: 'CHEQUE',

          handler: () => {
            console.log('cheque clicked');
            this.payment_type = 2;
          }
        }
      ]
    });

    actionSheet.present();
  }

  BackClicked() {
    let local = new Locals();
    local.stype = this.stype;
    local.ptype = this.payment_type;
    local.accdetail = this.Account_detail;
    local.tokenfrom = this.token_numbersfrom;
    local.tokento = this.token_numbersto;
    local.tokens = this.token_numbers;
    local.sprequest = this.sp_request;
    local.addlppl = this.addl_people;
    this.navCtrl.push(CalanderPage, { user: this.user, calendar_details: this.calander_details, sevas_booked: ((this.selected_seva_array.length > 0) ? this.selected_seva_array : null), local: local })
  }

  CalculateHasthodakaAmount() {
    //return !(event.charCode == 46 || event.charCode == 45)"
    if (Number(this.addl_people) > 0) {
      console.log("inside CalculateHasthodakaAmount() this.addlppl", this.addl_people)

      // let searchForHasthodakaAdradana_local = this.selected_seva_array.find(item => item.sevaname == 'Hastodaka - Adradhana (Y)');

      let searchForHasthodakaAdradana_local = this.selected_seva_array.find(item => ((item.sevaname.toUpperCase().includes('HASTODAKA'))));

      let index = this.selected_seva_array.indexOf(searchForHasthodakaAdradana_local);
      console.log("index after finding hasthodaka", index);
      console.log("searchforhasthodaka", searchForHasthodakaAdradana_local);

      if (index < 0) {
        //Please select the Aradhane Hastodaka

        //  let alert = this.alertController.create({
        //   title: 'Alert',
        //   subTitle: 'Please select Hastodaka seva before adding extra persons.',
        //   cssClass: 'buttonCsstext',
        //   buttons: [
        //     {
        //       text: 'Ok',
        //       cssClass: 'buttonCss',
        //       role: 'cancel',
        //       handler: () => {
        //         this.addl_people = 0;
        //       }
        //     }
        //   ]
        // });

        // alert.present();

        //  this.AddHasthodakaExtraAmount();
        //  this.CalculateTotal();

      }
      if (index >= 0) {

        searchForHasthodakaAdradana_local.sevaamount = searchForHasthodakaAdradana_local.sevaamount * this.addl_people;
        console.log("came here")
        searchForHasthodakaAdradana_local.persons_included = this.addl_people;
        this.CalculateTotal();
      }
      // this.AddHasthodakaExtraAmount();
      // this.CalculateTotal();
    }
  }

  updateEndToken() {
    let temp = 0;
    this.tokensum = 0;
    console.log(this.selected_seva_array.length)
    for (let m = 0; m < this.selected_seva_array.length; m++) {
      temp = +temp + (this.selected_seva_array[m].persons_included)
    }
    this.tokensum = +(this.tokensum) + +(temp);
    //this.token_numbersfrom = 0;
    console.log("total token inside update token:", this.tokensum);
    console.log("already we have tokensfrom:", this.token_numbersfrom);
    // if(this.token_numbersfrom > 0)
    // {
    //   this.tokensum = this.token_numbersfrom - this.token_numbersfrom
    // }
    //this.CalculateTotal();
    // if(this.tokensum == 0 && this.token_numbersfrom == 0)
    // {
    //   this.token_numbersto = +(this.token_numbersfrom)   +  +(this.tokensum);
    // }
    if (this.tokensum == 0) {
      this.token_numbersto = 0;
      this.token_numbersfrom = 0;
    }
    else {
      if (this.token_numbersfrom > 0) {
        this.token_numbersto = +(this.token_numbersfrom) + +(this.tokensum - 1);
      }

    }

    console.log("tokennumbersto", this.token_numbersto)
  }
  showCurrentShashwathaSevaUsersList() {
    let t: Locals = this.navParams.get('local');
    console.log("local before passsing to popover page", t)
    this.navCtrl.push(PopoverPage, { calendar: this.calander_details, user: this.user, local: this.selected_seva_array })
    // let popover = this.popoverCtrl.create(PopoverPage,{id:this.selected_seva_array[0].id});
    // popover.present({
    //    });

  }
  showWeekDays() {
    this.showweekdays = true;
  }
  setWeekDay(w) {
    if (w) {
      this.week_day = w;
    }
    this.showweekdays = false;
  }
  showThithis() {
    this.showthithis = !this.showthithis;
  }
  setThithi(t: Tithi) {
    if (t) {
      this.thithi_for_shashwathaseva = t.name;
      if (this.thithi_for_shashwathaseva.toUpperCase() == 'POORNIMA') {
        this.paksha_for_shashwathaseva = 'Shukla';
      }
      if (this.thithi_for_shashwathaseva.toUpperCase() == 'AMAVASYA') {
        this.paksha_for_shashwathaseva = 'Krishna';
      }
    }
    this.showthithis = false;
    if (this.thithi_for_shashwathaseva != 'None') {
      this.disablenakshatra = true;
    }
    else {
      this.disablenakshatra = false;
    }
  }
  showPaksha() {
    this.showpaksha = !this.showpaksha;
  }
  setPaksha(p: Paksha) {
    if (p) {
      this.paksha_for_shashwathaseva = p.name;
    }
    this.showpaksha = false;
  }
  showNakshatra() {
    this.shownakshatra = !this.shownakshatra;
  }

  setNakshatra(n: Nakshatra) {
    if (n) {
      this.nakshatra_for_shashwathaseva = n.name;
    }
    this.shownakshatra = false;
    if (this.nakshatra_for_shashwathaseva != 'None') {
      this.disabletithi = true;
    }
    else {
      this.disabletithi = false;
    }
  }
  showMaasa() {
    this.showmaasa = !this.showmaasa;
  }

  setMaasa(m: Maasa) {
    if (m) {
      this.maasa_for_shashwathaseva = m.name;
    }
    this.showmaasa = false;
  }

  //ON SHASHWATHA SEVA CONFIRM CLICK
  onShashwathaConfirm() {
    if (this.selected_seva_array.length == 0) {
      console.log("inside zero seva selection case", this.selected_seva_array.length)
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Atleast one seva should be selected before booking',
        enableBackdropDismiss: false,
        cssClass: 'buttonCsstext',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();
      return
    }
    if ((this.selected_seva_array.length > 0) && (this.payment_type == null)) {
      console.log("inside zero seva selection case", this.selected_seva_array.length)
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Payment type should be selected before booking',
        enableBackdropDismiss: false,
        cssClass: 'buttonCsstext',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();
      return
    }
    if (((this.payment_type == 2) || (this.payment_type == 3) || (this.payment_type == 4)) && (this.Account_detail == null || this.Account_detail == ' ')) {

      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Card number not provided/Cheque number not provided',
        enableBackdropDismiss: false,
        cssClass: 'buttonCsstext',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();
      return
    }

    if ((this.mobile_number == null) || (this.name == null) || (this.seva_date == null)) {
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'All user details are mandatory for booking',
        enableBackdropDismiss: false,
        cssClass: 'buttonCsstext',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

      return
    }
    if (this.shashwatha_seva.toUpperCase().includes('HASTODAKA') && this.addl_people == 0) {
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Please enter the number of persons',
        enableBackdropDismiss: false,
        cssClass: 'buttonCsstext',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'buttonCss',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });

      alert.present();

      return
    }

    let alert = this.alertController.create({
      title: 'Alert',
      subTitle: 'Are you sure you want to confirm booking?',
      enableBackdropDismiss: false,
      cssClass: 'buttonCss',
      buttons: [
        {
          text: 'No',
          cssClass: 'nobutton',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Yes',
          cssClass: 'yesbutton',
          handler: () => {
            console.log('Yes clicked', this.mobile_number, this.name, this.gotra, this.seva_date);
            var postshashwathasevaobj = new ShashwathaSeva();
            //here posting must be done
            //Before calling the post method we should set the values to  object of postSevaBooking class(class is defined under models->PostSevaBooking)
            postshashwathasevaobj.phone = this.mobile_number;
            postshashwathasevaobj.name = this.name;
            postshashwathasevaobj.gotra = this.gotra;
            postshashwathasevaobj.nakshatra = this.nakshatra;
            postshashwathasevaobj.amount = this.seva_amount_total;
            postshashwathasevaobj.paymenttype = this.payment_type;
            postshashwathasevaobj.paymentnote = this.Account_detail;
            postshashwathasevaobj.special_request = this.sp_request;
            postshashwathasevaobj.start_date = this.datePipe.transform(this.fromdate, 'yyyy-MM-dd');
            postshashwathasevaobj.end_date = this.datePipe.transform(this.todate, 'yyyy-MM-dd');
            postshashwathasevaobj.seva_id = this.selected_seva_array[0].id;
            if (this.repeat_type == 'daily') {
              postshashwathasevaobj.repetition_type = 1;
            }
            if (this.repeat_type == 'weekly') {
              postshashwathasevaobj.repetition_type = 2;
            }
            if (this.repeat_type == 'monthly') {
              postshashwathasevaobj.repetition_type = 3;
            }
            if (this.repeat_type == 'yearly') {
              postshashwathasevaobj.repetition_type = 4;
            }
            console.log("weekday", this.week_day)
            var weekdaynum: number;
            let index = this.week_array.indexOf(this.week_day);
            console.log("index", index)
            switch (index) {
              case 0:
                console.log("came here")
                weekdaynum = 1;
                break;
              case 1: weekdaynum = 2;
                break;
              case 2: weekdaynum = 3;
                break;
              case 3: weekdaynum = 4;
                break;
              case 4: weekdaynum = 5;
                break;
              case 5: weekdaynum = 6;
                break;
              case 6: weekdaynum = 7;
                break;
            }
            postshashwathasevaobj.weekday = weekdaynum;
            console.log("weekday", postshashwathasevaobj.weekday)
            var find_maasa = this.maasa_array.find((item) => { return item.name == this.maasa_for_shashwathaseva })
            if (find_maasa) {
              postshashwathasevaobj.maasa = find_maasa.id;
            }
            var find_tithi = this.thithi_array.find((item) => { return item.name == this.thithi_for_shashwathaseva })
            if (find_tithi) {
              postshashwathasevaobj.tithi = find_tithi.id;
            }
            var find_nakshatra = this.nakshatra_array.find((item) => { return item.name == this.nakshatra_for_shashwathaseva })
            if (find_nakshatra) {
              postshashwathasevaobj.seva_nakshatra = find_nakshatra.id;
            }
            postshashwathasevaobj.paksha = (this.paksha_for_shashwathaseva == 'Shukla') ? 1101 : 1102;
            let starthours: any;
            console.log("seva time", this.seva_time)
            if (this.seva_time) {
              starthours = this.seva_time.split(':');
              let start_am_pm: any;
              let end_am_pm: any;
              if (starthours[0] > 12) {
                start_am_pm = "PM";
                this.seva_time = this.seva_time + ' ' + start_am_pm;
              }
              else {
                start_am_pm = "AM";
                this.seva_time = this.seva_time + ' ' + start_am_pm
              }
              postshashwathasevaobj.reporting_time = this.seva_time;
            }

            //for testing
            console.log("this.postseva.reporting_time", this.postseva.reporting_time)
            postshashwathasevaobj.seva_time = this.seva_time;
            console.log(this.token_numbersfrom, this.token_numbersfrom)

            postshashwathasevaobj.tokendetails = ((this.token_numbersfrom && this.token_numbersto)) ? (this.token_numbersfrom + '-' + this.token_numbersto) : (' ');
            this.postseva.bookingtype = "M";

            postshashwathasevaobj.date = this.datePipe.transform(this.calander_details.date, "yyyy-MM-dd");
            console.log("postobj before passing", postshashwathasevaobj);

            this.restProvider.postShashwathaBooking(postshashwathasevaobj)
              .subscribe(
                (result) => {
                  console.log("result from recurringsevas boking api", result);
                  let alert = this.alertController.create({
                    title: 'Alert',
                    subTitle: 'Seva booking successful',
                    enableBackdropDismiss: false,
                    cssClass: 'buttonCsstext',
                    buttons: [
                      {
                        text: 'Ok',
                        cssClass: 'buttonCss',
                        role: 'cancel',
                        handler: () => {
                        }
                      }
                    ]
                  });

                  alert.present();




                  console.log("rectno passed to show the pdf after booking:", result)
                  this.restProvider.getShashwathaSevaReipt(result).subscribe(
                    (res) => {

                      console.log('res', res);
                      var fileURL = URL.createObjectURL(res);
                      console.log(fileURL)
                      this.ClearAllFields();
                      
                      this.navCtrl.push(CalanderPage);
                      window.open(fileURL);
                    }
                  );
                },
                error => {
                  console.log(error.statusText);
                  console.log(error);
                  let alert = this.alertController.create({
                    title: 'Alert',
                    subTitle: 'Seva booking unsuccessful',
                    enableBackdropDismiss: false,
                    cssClass: 'buttonCsstext',
                    buttons: [
                      {
                        text: 'Ok',
                        cssClass: 'buttonCss',
                        role: 'cancel',
                        handler: () => {
                        }
                      }
                    ]
                  });

                  alert.present();

                  return

                }
              )
          }
        }
      ]
    });

    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts